import { render } from "./SettingsLayout.vue?vue&type=template&id=64c6fbc9&scoped=true"
import script from "./SettingsLayout.vue?vue&type=script&lang=js"
export * from "./SettingsLayout.vue?vue&type=script&lang=js"

import "./SettingsLayout.vue?vue&type=style&index=0&id=64c6fbc9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c6fbc9"],['__file',"src/layout/SettingsLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64c6fbc9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64c6fbc9', __exports__)) {
    api.reload('64c6fbc9', __exports__)
  }
  
  module.hot.accept("./SettingsLayout.vue?vue&type=template&id=64c6fbc9&scoped=true", () => {
    api.rerender('64c6fbc9', render)
  })

}


export default __exports__